import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppContext } from './AppContext'; // <- import from your file
import Login from './Login';
import Signup from './Signup';
import { supabase } from './supabaseClient';

const allCandles = {}; // replace this with your actual candle data

// AuthGate — gates the whole app above <App />, so App's mount effects / network
// scans never run until authenticated. No session → Login; session → the app,
// rendered EXACTLY as before. Session restores across refresh via getSession().
function AuthGate() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState("login"); // no-session surface: 'login' | 'signup'

  useEffect(() => {
    // Restore an existing session on mount.
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    // Keep session in sync (login, logout, token refresh).
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return null; // avoid a flash of Login before the session restores
  if (!session) {
    // Same no-session surface as before, now toggling Login ↔ Signup. Session logic unchanged:
    // a successful signup/login fires onAuthStateChange, which flips session and renders <App/>.
    return mode === "signup"
      ? <Signup onShowLogin={() => setMode("login")} />
      : <Login onShowSignup={() => setMode("signup")} />;
  }
  return (
    <AppContext.Provider value={{ allCandles }}>
      <App />
    </AppContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthGate />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
